module.exports = __webpack_public_path__ + "static/media/fantom.8e6b7c56.svg";